export default {
    activateuser: {
        headerLabel: 'Giới thiệu người dùng',
        accountActivation: 'Kích hoạt tài khoản',
        step1: {
            header: 'Chào mừng đến với nền tảng của chúng tôi!',
            subHeader: 'Chọn cách bạn muốn kết nối với tài khoản của mình',
            description:
                'Để quá trình đăng nhập đơn giản hơn, chúng tôi khuyên bạn nên kết nối tài khoản của mình với ít nhất một trong các dịch vụ sau.',
            OR: 'hoặc',
            emailAndPassword: 'Sử dụng email của riêng bạn',
        },
        step2: {
            header: 'Sử dụng email và mật khẩu',
            description:
                'Đây là email chính sẽ được liên kết với tài khoản của bạn. Chúng tôi khuyên bạn nên sử dụng một email khác với địa chỉ trường đại học của bạn để giữ quyền truy cập vào dữ liệu của bạn sau khi bạn tốt nghiệp. Bạn có thể dễ dàng kiểm soát những email bạn nhận được từ chúng tôi trong cài đặt tài khoản của bạn.',
            invalidEmail: 'Email được cung cấp không phải là một email hợp lệ.',
            passwordsNotMatch: 'Mật khẩu phải khớp',
            passwordDescription01:
                'Để đảm bảo an toàn cho tài khoản của bạn, bạn cần đặt một mật khẩu mới. Vui lòng tạo mật khẩu như sau:',
            passwordDescription02: 'Tối thiểu 8 ký tự',
            passwordDescription03: 'Ít nhất một ký tự viết thường (a-z)',
            passwordDescription04: 'Ít nhất một ký tự viết hoa (A-Z)',
            passwordDescription05: 'Ít nhất một số hoặc ký hiệu đặc biệt (0-9,! # $, v.v.)',
            passwordDescription06: 'Ít nhất 6 ký tự duy nhất',
            repeatPassword: 'Lặp lại mật khẩu',
        },
        step3: {
            header: 'Đang kích hoạt người dùng',
            loadingHints: {
                0: 'Đang tải dữ liệu người dùng',
                1: 'Chuẩn bị mọi thứ sẵn sàng',
                2: 'Tính năng mới sắp được ra mắt',
                3: 'Sắp xong!',
            },
            successHeader: 'Tài khoản của bạn hiện đã sẵn sàng hoạt động!',
            successSubheader: 'Bây giờ bạn có thể truy cập các tính năng độc quyền!',
            errorHeader: 'Không thể kích hoạt tài khoản',
            ifWrongContact: 'Nếu bạn cho rằng điều này là sai, vui lòng liên hệ với bộ phận hỗ trợ',
            contactForHelp: 'Liên hệ để được giúp đỡ',
            goBack: 'Quay lại',
        },
    },
    assessments: {
        general: {
            checkMyProgress: 'Kiểm tra tiến trình của tôi',
            getStarted: 'Bắt đầu!',
            getToKnowYourself: 'Tìm hiểu bản thân',
            getToKnowYourselfBold: 'Tìm hiểu <strong>bản thân bạn</strong>',
            getToKnowYourFuture: 'Tìm hiểu tương lai của bạn',
            getToKnowYourFutureBold: 'Tìm hiểu <strong>tương lai</strong> của bạn',
            openAssessments: 'Mở đánh giá',
            openAssessment: 'Mở đánh giá',
            unlock: 'Mở khóa các bài kiểm tra',
            testYourself: 'Tự kiểm tra',
            takeTheFreeTests: 'Làm các bài kiểm tra miễn phí',
            youOwnThisProduct: 'Bạn sở hữu sản phẩm này',
            startTest: 'Bắt đầu kiểm tra',
            startTests: 'Bắt đầu kiểm tra',
            continue: 'Tiếp tục',
            showReport: 'Hiển thị báo cáo',
            showYourReports: 'Hiển thị báo cáo của bạn',
            showYourReport: 'Hiển thị báo cáo của bạn',
            continueFreeTests: 'Tiếp tục các bài kiểm tra miễn phí',
            continueTheTest: 'Tiếp tục bài kiểm tra',
            estimatedTime: '~ {min} phút',
        },
        landing: {
            section1: {
                title: 'Tự Kiểm tra',
                description01:
                    'Chào mừng bạn đến với Trung tâm Đánh giá - đây là nơi bắt đầu hành trình sự nghiệp của bạn.',
                description02:
                    'Đây là nơi bạn có thể thực hiện <strong>Bài kiểm tra Aon</strong>, bài kiểm tra được sử dụng bởi các nhà tuyển dụng trên toàn thế giới, nhằm kiểm tra khả năng và sự sẵn sàng của bạn cho sự nghiệp tương lai.',
                freemium: {
                    description:
                        'Thực hiện các bài kiểm tra này để đánh giá điểm mạnh của bạn và nhận báo cáo hiệu quả về kỹ năng của bạn.',
                    price: 'Miễn phí',
                    numTests: '3 bài kiểm tra',
                    timeEstimated: 'xấp xỉ. 27 phút',
                },
                premium: {
                    description:
                        'Đây là <strong>tính năng vượt trội</strong>. Thực hiện bài kiểm tra 3 trong 1 này để tìm ra con đường sự nghiệp bạn nên theo đuổi và nhận Báo cáo Ứng viên đầy đủ.',
                    numTests: 'Kiểm tra 3 trong 1',
                    timeEstimated: 'xấp xỉ 60 phút',
                    sampleReport: '↓ Tải xuống Mẫu Báo cáo',
                    candidateReport: 'Báo cáo Ứng viên',
                    candidateReportDescription:
                        'Sau khi hoàn thành các bài kiểm tra này, bạn sẽ nhận được Báo cáo Ứng viên đầy đủ với tổng quan toàn diện về kết quả của bạn, bao gồm các mẹo về cải thiện bộ kỹ năng cá nhân, kỹ năng nào bạn nên chú ý, cơ hội tốt nhất để bắt đầu, bước tiếp theo của bạn là gì, và nhiều hơn nữa.',
                },
            },
            section2: {
                title: 'Làm thế nào những bài kiểm tra này sẽ giúp bạn được tuyển dụng?',
                t1: 'Bạn sẽ biết <strong>những kỹ năng</strong> của bạn',
                t2: 'Bạn sẽ nhận ra <strong>tiềm năng</strong> của bạn',
                t3: 'Bạn sẽ có một <strong>con đường phát triển sự nghiệp</strong> rõ ràng',
                t4: 'Bạn sẽ tăng cường <strong>sự tự tin</strong> của mình',
            },
            section3: {
                title: 'Tìm hiểu về điểm mạnh cá nhân và cơ hội nghề nghiệp của bạn để thúc đẩy sự phát triển và thăng tiến nghề nghiệp của bạn.',
            },
            section4: {
                title: 'Đi trước đối thủ cạnh tranh của bạn ngay hôm nay',
                description:
                    'bằng cách hoàn thành các bài đánh giá được sử dụng bởi các nhà tuyển dụng trên toàn thế giới tại các công ty như Deloitte, Siemens, Burger King, Vodafone hoặc P&G.',
            },
            section5: {
                title: 'Các Câu hỏi Thường gặp',
                thisPage: 'trang này',
                question01: {
                    q: 'Đánh giá Aon là gì?',
                    a: 'Đánh giá nhân tài của Aon là bài kiểm tra được công nhận trên toàn cầu giúp các công ty trên toàn thế giới xác định những ứng viên tốt nhất cho công việc. Với sự trợ giúp của đánh giá tài năng, các nhà tuyển dụng có thể xem xét ngoài CV, điểm số tại trường học, chứng chỉ đại học và bằng tốt nghiệp đại học để tìm ra ứng viên có phù hợp hay không.\n                <br><br>\n                Các giải pháp này thường được dành riêng <strong>cho nhà tuyển dụng</strong> - tại đây, bạn có cơ hội <strong>độc quyền</strong> để thực hành và nhận kết quả trước cuộc phỏng vấn xin việc. Hầu hết các ứng viên khác không có cơ hội này, vì vậy hãy tận dụng nó!',
                },
                question02: {
                    q: 'Tôi có cần trả tiền để thực hiện các bài đánh giá này không?',
                    a: 'Bạn có thể làm 4 bài kiểm tra trong số này miễn phí - <i>Hành vi liên quan đến công việc</i>, <i>Tính nhanh</i>, <i>Tư duy Suy luận logic</i>, và <i>Lập luận Quy nạp logic</i>. Các bài kiểm tra này đo lường kỹ năng và năng khiếu của bạn và là một cách tuyệt vời để tìm ra điểm mạnh và điểm yếu của bạn.\n\n                <br><br>Tuy nhiên, nếu bạn muốn có cái nhìn tổng quan đầy đủ về các khuynh hướng phát triển của mình, có được thông tin chuyên môn về con đường sự nghiệp phù hợp nhất với bạn và tiến một bước dài trên con đường hướng tới thành công trong tương lai, bạn cũng có thể truy cập vào bài kiểm tra 3 trong 1 và nhận Báo cáo Ứng viên toàn diện với giá 79€ . <br><br>Để có quyền truy cập mở rộng, chỉ cần <a href={premiumLink}>ấn vào đây</a> và thanh toán bằng thẻ - chúng tôi đảm bảo sử dụng phương thức thanh toán an toàn.\n',
                },
                question03: { q: 'Tại sao tôi nên làm các bài kiểm tra này?' },
                question04: {
                    q: 'Tôi có thể chuẩn bị cho những bài kiểm tra này như thế nào?',
                    a: 'Bạn có thể tìm tất cả các yêu cầu kỹ thuật và cách chuẩn bị cho các bài đánh giá trên <a href={link} target="_blank">trang này</a>. Ở đó, bạn cũng sẽ tìm thấy tài liệu giúp bạn đạt kết quả cao trong bài đánh giá',
                },
                question05: {
                    q: 'Tôi có thể tìm thấy những đánh giá này ở đâu khác?',
                    a: 'Thông thường, bạn sẽ được nhà tuyển dụng yêu cầu hoàn thành các bài kiểm tra này - ngoài ra, bạn sẽ không tìm thấy những bài kiểm tra này ở bất kỳ nơi nào khác. Đây là cơ hội dành riêng cho bạn để thực hành, tìm hiểu thêm về bản thân và nghề nghiệp trong tương lai.',
                },
                question06: {
                    q: 'Tôi có thể làm bài kiểm tra bao nhiêu lần?',
                    a: 'Bạn chỉ nhận được một lần cho mỗi bài kiểm tra. Không thi lại! Hãy chắc chắn rằng bạn có điều kiện thoải mái để tận dụng nó để tận dụng tối đa cơ hội này. Bạn có thể tự làm quen với bài kiểm tra bằng cách xem video hướng dẫn trên màn hình và làm bài tập thực hành trước khi làm bài kiểm tra.',
                },
                question07: {
                    q: 'Những bài kiểm tra này bằng ngôn ngữ nào?',
                    a: '\n                Ngôn ngữ mặc định cho các bài kiểm tra này là tiếng Anh, tuy nhiên, mỗi bài kiểm tra đều có nhiều ngôn ngữ khác nhau để bạn lựa chọn. Bạn có thể kiểm tra những ngôn ngữ có sẵn và chọn ngôn ngữ phù hợp với bạn nhất trước khi làm bài kiểm tra. \n',
                },
                question08: {
                    q: 'Có ngày hết hạn đối với các bài kiểm tra mở rộng khi tôi trả tiền cho chúng không?',
                    a: 'Không! Sau khi thanh toán của bạn được chấp nhận, bạn có thể thực hiện các bài kiểm tra mở rộng bất cứ khi nào bạn muốn. Hãy dành thời gian để chuẩn bị và bắt đầu đánh giá bất cứ lúc nào phù hợp với bạn nhất.',
                },
            },
        },
        center: {
            banner: {
                title: 'Kiểm tra sự tiến bộ của bạn',
                subtitle:
                    'Đây là tổng quan về sự tiến bộ của bạn trong các bài đánh giá nghề nghiệp',
                moreInfo: 'Thêm thông tin',
                yourProgress: 'Tiến trình của bạn',
                quote: 'Đặt mục tiêu là bước đầu tiên để biến cái vô hình thành cái nhìn thấy được.',
            },
            list: {
                timeEstimated: 'xấp xỉ {phút} phút',
                freemium: {
                    intro: '\n                    Đây là bước đầu tiên trong hành trình phát triển cá nhân của bạn! <br />\n                    Thực hiện các bài kiểm tra này để xác định điểm mạnh của bạn và nhận báo cáo hiệu quả về \n                    các kỹ năng của bạn.\n',
                },
                premium: {
                    intro: '\n Đây là một tính năng vượt trội.<br />\n Làm các bài kiểm tra này để tìm ra con đường sự nghiệp bạn nên theo đuổi và nhận\n <strong>Báo cáo Ứng viên</strong> toàn diện.\n',
                    description:
                        '\n                    <strong>Báo cáo Ứng viên</strong> sẽ cung cấp cho bạn một cái nhìn toàn diện\n                    về kết quả của bạn, bao gồm cả <strong>các mẹo</strong> để cải thiện\n                    bộ kỹ năng cá nhân của bạn, đó là <strong>những kỹ năng</strong> bạn nên chú ý đến,\n                    <strong>cơ hội</strong> tốt nhất để bắt đầu\n                    <strong>bước tiếp theo</strong> của bạn là gì và hơn thế nữa.\n',
                },
            },
            instruments: {
                344: {
                    name: 'Tư duy Suy luận logic',
                    description:
                        'Đánh giá mức độ thành thạo của bạn trong việc sử dụng kiến ​​thức và áp dụng các quy tắc - bài kiểm tra này đo lường khả năng phân tích và giải quyết vấn đề của bạn.',
                    estimatedTime: '9',
                },
                383: {
                    name: 'Lập luận Quy nạp logic',
                    description:
                        'Bạn có thể xác định các quy tắc và mối tương quan tốt như thế nào? Xác định với bài kiểm tra này để đo khả năng phân tích và giải quyết vấn đề của bạn.',
                    estimatedTime: '9',
                },
                390: {
                    name: 'Hành vi liên quan đến công việc',
                    description:
                        'Tính cách đặc trưng của một người nhân viên mà bạn có là gì? Tìm hiểu bằng cách làm bài kiểm tra này để xác định các đặc điểm tính cách dựa trên công việc của bạn.',
                    estimatedTime: '30',
                },
                721: {
                    name: 'Đánh số Thứ tự',
                    description:
                        'Bạn giỏi đến mức nào với những con số lắt léo? Bài kiểm tra này sẽ đo lường sự hiểu biết của bạn về thông tin dạng số và đưa ra kết luận logic.',
                    estimatedTime: '9',
                },
                5392: {
                    name: 'Bộ nhớ Làm việc',
                    description:
                        'Bạn có thể tập trung tốt như thế nào? Bài kiểm tra này sẽ đo lường khả năng xử lý và ghi nhớ thông tin trong môi trường gây mất tập trung.',
                    estimatedTime: '15',
                },
                82013: {
                    name: 'Bài kiểm tra độ linh hoạt',
                    description:
                        'Sở thích của bạn là gì? Bảng câu hỏi này sẽ giúp xác định con đường sự nghiệp mà bạn có thể muốn theo đuổi.',
                    estimatedTime: '15',
                },
            },
        },
        dialog: {
            header: 'Bắt đầu đánh giá Aon của bạn',
            consent:
                'Tôi hiểu rằng Aon chịu trách nhiệm về những dữ liệu liên quan đến bài đánh giá này và đồng ý với các điều khoản và điều kiện của họ.\n               Tôi cũng đồng ý rằng Highered có thể chuyển tên của tôi thành Aon để tạo báo cáo của tôi.',
            startTest: 'Bắt đầu kiểm tra',
            consentErrorTitle: 'Lỗi đồng ý',
            consentErrorMessage:
                'Đã xảy ra sự cố khi gửi sự đồng ý của bạn. Bạn đã xác nhận email của mình chưa?',
        },
    },
    calendar: {
        header: 'Lịch',
        myCalendar: 'Lịch của tôi',
        noCalendar: 'Dịch vụ nghề nghiệp của bạn chưa kích hoạt tính năng lịch.',
        goBackBtn: 'Quay lại',
        calendarNotReady:
            'Chức năng "lịch của tôi" chưa sẵn sàng. Chức năng này sẽ sớm được ra mắt',
        noUpcomingAppointments: 'Bạn không có cuộc hẹn nào sắp diễn ra.',
        appointmentMissing: 'Cuộc hẹn không hoạt động',
        appointmentNotActive:
            'Xin lỗi, bạn đã cố gắng xem một cuộc hẹn không tồn tại hoặc không hoạt động.',
        appointmentNotHavingAvailability:
            'Xin lỗi, cuộc hẹn này không có sẵn vào lúc này. Hãy kiểm tra lại sau.',
        appointmentMissingRules: 'Cuộc hẹn không còn chỗ trống',
        needToCompleteProfile: 'Hoàn thành hồ sơ của bạn',
        noUpcomingAppointmentsPleaseBook: 'Đặt một cuộc hẹn để mở khóa lịch của bạn.',
        bookAppointment: 'Đặt lịch hẹn',
        bookAnotherAppointment: 'Đặt một cuộc hẹn',
        attendedAppointments: 'Các cuộc hẹn bạn đã tham dự',
        aboutAppointments: {
            header: 'Về các cuộc hẹn',
            button: 'Về',
            block1: { header: 'Cuộc hẹn là gì?' },
            block2: { header: 'Tôi có thể liên hệ với ai để biết thêm thông tin?' },
        },
        bookAnAppointment: 'Đặt Lịch hẹn',
        backToCalendarBtn: 'Quay lại lịch',
        backToBookingBtn: 'Quay lại danh sách cuộc hẹn',
        firstAvailable: 'Có sẵn đầu tiên',
        loadingAppointment: 'Đang tải ...',
        bookModal: {
            title: 'Xác nhận đặt chỗ',
            with: 'Với',
            confirm: 'Xác nhận',
            continue: 'Tiếp tục',
            cancel: 'Đóng',
            first: {
                title: 'Đây là cuộc hẹn đầu tiên của bạn',
                description:
                    'Để đảm bảo bạn nhận được lời mời tham gia sự kiện, vui lòng xác nhận rằng bạn có quyền truy cập vào lịch cá nhân thông qua tài khoản e-mail này',
                ok: 'VÂNG',
                wrongEmail: 'Sai địa chỉ email?',
            },
            changeEmail: {
                title: 'Chọn e-mail cho lịch của bạn',
                inputPlaceholder: 'Nhập email ...',
                ok: 'VÂNG',
                back: 'Sử dụng chế độ mặc định',
            },
            unknownErrorHeader: 'Đã xảy ra lỗi khi cố gắng đặt trước',
            unknownErrorBody:
                'Vui lòng thử đặt chỗ vào lúc khác và nếu cách này không hiệu quả, hãy liên hệ với bộ phận hỗ trợ.',
            confirmationHeader: 'Cuộc hẹn của bạn đã được đặt trước!',
            bookedTheFollowing: 'Chi tiết:',
            emailWillBeSent: 'Một e-mail sẽ được gửi đến',
            withConfirmation: 'yêu cầu bạn xác nhận sự tham dự của bạn.',
        },
        dateDetailsModal: { title: 'Các cuộc hẹn vào' },
        completedYourProfile:
            'Bạn cần hoàn thành hồ sơ của mình để có quyền truy cập vào hệ thống lịch',
        toMyProfile: 'Chỉnh sửa hồ sơ của tôi',
    },
    chat: {
        profileSharingConfirmDialog: {
            title: '{tên} muốn xem hồ sơ của bạn',
            content: 'Bạn có muốn chia sẻ hồ sơ của bạn với người này?',
            share: 'Chia sẻ hồ sơ',
            reject: 'Không',
        },
    },
    companyDetail: {
        locations: {
            header: 'Địa điểm',
            viewAll: 'Xem toàn bộ',
            noLocations: 'Không có địa điểm',
            allLocations: 'Tất cả địa điểm',
        },
        jobModule: {
            header: 'Những vị trí hàng đầu',
            viewAllJobs: 'Xem tất cả các công việc từ {Têncôngty}',
            noPositions: '{Têncôngty} hiện không có bất kỳ vị trí còn trống nào tại Highered.',
            defaultLabel: 'Vị trí còn trống',
        },
        videos: {
            header: 'Video',
            noVideos: 'Không có video',
            noMoreVideos: 'Không còn video nào',
            moreVideosFrom: 'Nhiều video từ {Têncôngty}',
        },
        articles: {
            header: 'Bài viết',
            noArticles: 'Không có bài viết',
            noMoreArticles: 'Không còn bài viết nào',
            moreArticlesFrom: 'Xem thêm bài viết từ {Têncôngty}',
        },
    },
    components: {
        builders: {
            searchable: { create: 'Tạo' },
            yearMonthPicker: { defaultSelect: 'Chọn một tháng' },
            localeDropdown: {
                languages: {
                    en: 'Tiếng Anh',
                    cn: 'Tiếng Trung Quốc',
                    fr: 'Tiếng Pháp',
                },
            },
        },
        miscellaneous: {
            verifyModule: {
                title: 'Xác nhận e-mail tại trường học của bạn',
                verificationPending: 'Xác minh đang chờ xử lý',
                weHaveSentAnEmail:
                    'Chúng tôi đã gửi e-mail tới\n                                <strong>{Email học sinh}</strong> để\n                                bạn xác minh danh tính. Đảm bảo\n                                kiểm tra thư mục spam của bạn, vì nhiều trường học\n                                khá nghiêm ngặt đối với các email đến.',
                verifyMe: 'Xác minh tôi',
                resendVerifyEmail: 'Gửi lại email xác minh',
                cancelVerification: 'Hủy xác minh',
                emailSent: 'Đã gửi email',
                emailSentMessage:
                    'Email đã được gửi thành công. Nếu bạn không nhận được nó, hãy liên hệ với chúng tôi theo địa chỉ support@highering.global.',
                resendErrorTitle: 'Lỗi khi gửi lại email',
                resendErrorMessage:
                    'Không thể gửi lại email xác minh. Vui lòng liên hệ với chúng tôi theo địa chỉ support@highering.global.',
                verificationCancelledTitle: 'Đã hủy xác minh',
                verificationCancelledMessage: 'Xác minh đã được hủy thành công.',
                cancelErrorTitle: 'Lỗi khi hủy',
                cancelErrorMessage:
                    'Không thể hủy xác minh. Vui lòng liên hệ với chúng tôi tại support@highering.global.',
            },
            verifyModuleDialog: {
                title: 'Xác minh e-mail tại trường học của bạn',
                university: 'Viện Hàn lâm',
                studentEmail: 'Địa chỉ e-mail học tập của bạn',
                studentEmailPlaceholder: 'Email học thuật',
                message: 'Tin nhắn',
                verify: 'Xác nhận',
                sendRequest: 'Gửi yêu cầu',
                verificationInProcess: 'Đang xác minh',
                emailHasBeenSentTo:
                    'Một email đã được gửi đến <strong>{email}</strong> Làm theo hướng dẫn ở đó để xác minh kết nối của bạn với <strong>{Tên trường học}</strong>',
                verificationRequestSentNonAcademic:
                    'Các dịch vụ nghề nghiệp tại <strong>{Tên trường học}</strong> sẽ cần xác minh kết nối của bạn. Bạn sẽ được thông báo qua email khi điều đó xảy ra.',
                ifNoEmailRecieved:
                    'Nếu bạn chưa nhận được thư xác minh, vui lòng liên hệ với chúng tôi.',
                contactHelp: 'Liên hệ với chúng tôi để được giúp đỡ',
                doNotHaveAcademicEmail: 'Tôi không có địa chỉ email học thuật',
                doubleCheckEmail:
                    'Vui lòng kiểm tra kỹ xem địa chỉ email này có đúng không và bạn có quyền truy cập vào địa chỉ đó không.',
                haveAcademicEmail: 'Tôi có một địa chỉ email học thuật',
                noAcademicEmailInfo:
                    'Nếu bạn không sử dụng địa chỉ email học thuật, yêu cầu của bạn sẽ cần được các dịch vụ nghề nghiệp phê duyệt theo cách thủ công. Do đó, bạn phải cung cấp một thông điệp ngắn để xác minh bản thân.',
                alreadyVerifiedInfo: 'Bạn đã được xác minh tại trường này.',
            },
        },
        navigation: {
            navigation: {
                myPage: 'Trang của tôi',
                jobs: 'Việc làm',
                companies: 'Các công ty',
                masterclasses: 'Masterclasses',
                assessments: 'Đánh giá',
                countryGuides: 'Hướng dẫn quốc gia',
                goToHaigui: 'Việc làm ở Trung Quốc',
                signIn: 'Đăng nhập / Đăng ký',
                vfairs: 'Sự kiện Ảo',
                events: 'Sự kiện',
                newFeature: 'Tính năng Mới!',
            },
            profileNavigation: { signOut: 'Đăng xuất' },
            sidebar: {
                myPage: 'Trang của tôi',
                myProfile: 'Thông tin của tôi',
                findJobs: 'Tìm việc',
                findCompanies: 'Tìm công ty',
                masterclasses: 'Masterclasses',
                assessments: 'Đánh giá',
                countryGuides: 'Hướng dẫn Quốc gia',
                goToHaigui: 'Việc làm ở Trung Quốc',
                virtualFairs: 'Sự kiện Ảo',
                logOut: 'Đăng xuất',
            },
            backToCalendar: 'Quay lại lịch',
            allBooths: 'Tất cả các gian hàng',
            home: 'Trang chủ',
        },
        smart: {
            companyModule: {
                followJob: 'Thêm vào mục yêu thích',
                followCompany: 'Theo dõi công ty',
                unFollowJob: 'Loại bỏ khỏi mục ưa thích',
                unFollowCompany: 'Bỏ theo dõi công ty',
                favoritedTitle: 'Đã lưu vào mục yêu thích',
                favoritedMessage:
                    'Vị trí này đã được lưu vào mục yêu thích của bạn. Tìm vị trí yêu thích của bạn tại trang của tôi.',
                unfavoritedTitle: 'Đã xóa khỏi mục yêu thích',
                unfavoritedMessage: 'Vị trí này đã bị xóa khỏi danh sách yêu thích của bạn.',
                favoriteErrorTitle: 'Đã xảy ra sự cố',
                favoriteErrorMessage: 'Không thể yêu thích vị trí này',
                showAllCompanies: 'Hiển thị tất cả các công ty',
                showOnlyCompaniesLiveOnChat: 'Chỉ hiện những công ty đang trực tuyến ',
            },
            profileModule: {
                profileCompletion: 'Hoàn thành hồ sơ',
                profileCompletionEncouragement:
                    'Thể hiện bản thân với nhà tuyển dụng bằng cách hoàn thành {sốphầntrăm} cuối cùng trong hồ sơ của bạn',
                gotoProfilePage: 'Cập nhật hồ sơ',
                profileCompleted: 'Hồ sơ đã hoàn thành',
                profileCompletedWhatsNext:
                    'Bạn có biết rằng hầu hết các nhà tuyển dụng đều sử dụng đánh giá trực tuyến trong quá trình tuyển dụng của họ? Thực hành ngay bây giờ và hiểu rõ hơn về điểm mạnh và điểm yếu của bạn.',
                gotoTestsPage: 'Đến trung tâm đánh giá',
                authIndication: {
                    title: 'Tìm công việc trong mơ của bạn',
                    description:
                        'Bạn có muốn tiếp cận các vị trí dành riêng cho trường học của bạn và các bài kiểm tra sẽ thúc đẩy quá trình tìm kiếm việc làm của bạn không? Dễ dàng tạo tài khoản với Google, LinkedIn hoặc Facebook ngay hôm nay.',
                    action: 'Hãy bắt đầu',
                },
                toProfileHint: 'Đến hồ sơ của tôi',
                toProfileUncompletedHint:
                    'Hồ sơ của bạn chưa hoàn chỉnh 100%. Vui lòng hoàn thành hồ sơ để tối đa hóa khả năng tuyển dụng của bạn.',
                profileActions: {
                    addFirstName: 'Thêm tên',
                    addLastName: 'Thêm họ',
                    addNationality: 'Thêm quốc tịch',
                    addPhoneNumber: 'Thêm số điện thoại của bạn',
                    addLanguage: 'Thêm một ngôn ngữ',
                    addEducation: 'Thêm trình độ học vấn',
                    addEmail: 'Thêm email của bạn',
                    addGender: 'Thêm giới tính của bạn',
                },
            },
            featuredCompanies: { label: 'Các công ty Nổi bật' },
            featuredPositions: { label: 'Vị trí Nổi bật' },
            featuredResource: {
                header: 'Tham gia Hội nghị Ảo',
                cta: 'Xem bây giờ!',
                wechatSignupHeader:
                    'Theo dõi tài khoản WeChat của Highered để nhận thông tin mới nhất',
            },
        },
    },
    cts: {
        filterNames: {
            employment_types: 'Các loại việc làm',
            education_level: 'Bằng cấp',
            education_fields: 'Lĩnh vực',
            job_category: 'Lĩnh vực',
            address: 'Địa điểm',
            sector: 'Các ngành',
            exclude_school_id: 'Không bao gồm',
            languages: 'Ngôn ngữ',
        },
        excludeSchoolIds: {
            '-1': 'Bài viết được chia sẻ',
            unknownSchoolId: 'Đối tác trường EFMD',
        },
        educationLevels: {
            BACHELORS_OR_EQUIVALENT: 'Cử nhân',
            MASTERS_OR_EQUIVALENT: 'Thạc sĩ',
            DOCTORAL_OR_EQUIVALENT: 'Tiến sĩ',
            MBA_OR_EQUIVALENT: 'Thạc sĩ quản trị kinh doanh',
            DBA_OR_EQUIVALENT: 'Quản trị hệ thống cơ sở dữ liệu',
        },
        employmentTypes: {
            FULL_TIME: 'Toàn thời gian',
            INTERN: 'Thực tập sinh',
            TEMPORARY: 'Bán thời gian',
            PART_TIME: 'Bán thời gian',
        },
        startDate: 'Bắt đầu',
        educationFields: {
            'Business Management Engineering': 'Kỹ thuật Quản lý Kinh doanh',
            Geology: 'Địa chất',
            'Sustainable Energy': 'Năng lượng bền vững',
            'Renewable Energy Engineering': 'Kỹ thuật Năng lượng tái tạo',
            'Architectural Engineering': 'Kỹ thuật Kiến trúc',
            'Structural Engineering': 'Kỹ thuật Kết cấu',
            'Energy Engineering': 'Kỹ thuật Năng lượng',
            'Executive Leadership': 'Lãnh đạo Cấp cao',
            'Electrical Engineering': 'Kỹ thuật Điện',
            'Corporate Governance': 'Quản trị Doanh nghiệp',
            'Automotive Engineering': 'Kỹ thuật Ô tô',
            'Maintenance and Operations': 'Bảo dưỡng và Vận hành',
            'Information Technology': 'Công nghệ Thông tin',
            Physics: 'Vật lý',
            'General Engineering': 'Kỹ thuật Tổng hợp',
            Chemistry: 'Hóa học',
            'Petroleum Engineering': 'Kỹ thuật Dầu mỏ',
            'Management Science': 'Khoa học Quản lý',
            'Computer Science Engineering': 'Kỹ thuật Khoa học Máy tính',
            'Software Engineering': 'Kỹ thuật Phần mềm',
            'Environmental Engineering': 'Kỹ thuật Môi trường',
            'Business law': 'Luật Doanh nghiệp',
            Psychology: 'Tâm lý học',
            Media: 'Truyền thông',
            Mathematics: 'Toán học',
            'Social Media': 'Mạng xã hội',
            'Natural Sciences': 'Khoa học Tự nhiên',
            Law: 'Luật',
            Biology: 'Sinh học',
            'Biomedical Engineering': 'Kỹ thuật Y sinh',
            'Forensic Accounting': 'Kế toán Pháp lý',
            'Retail Management': 'Quản lý Bán lẻ',
            'Event Management': 'Quản lý Sự kiện',
            Science: 'Khoa học',
            Engineering: 'Kỹ thuật',
            'Quality Management': 'Quản lý Chất lượng',
            'Master in Management (MiM)': 'Thạc sĩ Quản lý (MiM)',
            'Civil Engineering': 'Kỹ thuật Xây dựng',
            'Transport Management': 'Quản lý Giao thông',
            'BioMolecular Engineering': 'Kỹ thuật Biomolecular',
            'Safety Engineering': 'Kỹ thuật An toàn',
            'Master in Business Administration (MBA)': 'Thạc sĩ Quản trị Kinh doanh (MBA)',
            'Industrial Engineering': 'Kỹ thuật Công nghiệp',
            Marketing: 'Tiếp thị',
            'International trade': 'Thương mại Quốc tế',
            'International Business': 'Kinh doanh Quốc tế',
            'Public Administration': 'Quản trị Công',
            'Business Administration': 'Quản trị Kinh doanh',
            'Corporate Communication': 'Giao tiếp Doanh nghiệp',
            'Corporate Social Responsibility': 'Trách nhiệm Xã hội của Doanh nghiệp',
            'E-commerce': 'Thương mại điện tử',
            Consultancy: 'Tư vấn',
            Auditing: 'Kiểm toán',
            Banking: 'Ngân hàng',
            'Business Intelligence & Analytics': 'Trí tuệ Kinh doanh & Phân tích',
            Commerce: 'Thương mại',
            Agribusiness: 'Kinh doanh Nông nghiệp',
            Accounting: 'Kế toán',
            Finance: 'Tài chính',
            'Management, Organisation & Leadership': 'Quản lý, Tổ chức & Lãnh đạo',
            Economics: 'Kinh tế',
            Sales: 'Bán hàng',
            'Geo Engineering': 'Kỹ thuật Địa lý',
            'Marine Engineering': 'Kỹ thuật Hàng hải',
            'Climate Engineering': 'Kỹ thuật Khí hậu',
            'Real Estate': 'Bất động sản',
            Entrepreneurship: 'Khởi nghiệp',
            Taxation: 'Thuế',
            'Finance & Investment': 'Tài chính & Đầu tư',
            'Executive MBA': 'MBA cho Giám đốc điều hành',
            Sustainability: 'Bền vững',
            'Risk Management': 'Quản lý Rủi ro',
            'Project Management': 'Quản lý Dự án',
            'Human Resource Management': 'Quản lý Nhân sự',
            'Mechanical Engineering': 'Kỹ thuật Cơ khí',
            'Strategic Management': 'Quản lý Chiến lược',
            'Technology Management': 'Quản lý Công nghệ',
            'Supply Chain Management & Logistics': 'Quản lý Chuỗi cung ứng & Logistics',
            'Innovation Management': 'Quản lý Đổi mới',
        },
        jobCategories: {
            ACCOUNTING_AND_FINANCE: 'Kế toán và tài chính',
            ADMINISTRATIVE_AND_OFFICE: 'Hành chính và văn phòng',
            ADVERTISING_AND_MARKETING: 'Quảng cáo và tiếp thị',
            ART_FASHION_AND_DESIGN: 'Thời trang và thiết kế nghệ thuật',
            BUSINESS_OPERATIONS: 'Hoạt động kinh doanh',
            COMPUTER_AND_IT: 'Máy tính và công nghệ thông tin',
            CUSTOMER_SERVICE: 'Dịch vụ khách hàng',
            EDUCATION: 'Giáo dục',
            HEALTHCARE: 'Chăm sóc sức khỏe',
            HUMAN_RESOURCES: 'Quản trị nhân sự',
            INSTALLATION_MAINTENANCE_AND_REPAIR: 'Bảo trì và sửa chữa lắp đặt',
            LEGAL: 'Hợp pháp',
            MANAGEMENT: 'Ban quản lý',
            MANUFACTURING_AND_WAREHOUSE: 'Sản xuất và kho bãi',
            MEDIA_COMMUNICATIONS_AND_WRITING: 'Truyền thông đa phương tiện và viết lách',
            OIL_GAS_AND_MINING: 'Năng lượng',
            PROTECTIVE_SERVICES: 'Dịch vụ bảo vệ',
            REAL_ESTATE: 'Bất động sản',
            SALES_AND_RETAIL: 'Bán hàng và bán lẻ',
            SCIENCE_AND_ENGINEERING: 'Khoa học và kĩ thuật',
            SOCIAL_SERVICES_AND_NON_PROFIT: 'Dịch vụ xã hội và phi lợi nhuận',
            TRANSPORTATION_AND_LOGISTICS: 'Vận tải và hậu cần',
        },
        sectors: {
            Consulting: 'Tư vấn',
            'Consumer Goods': 'Hàng tiêu dùng',
            'Financial Services / Banking': 'Dịch vụ tài chính / Ngân hàng',
            'Goverment / Public Administration / Non Profit':
                'Chính phủ / Hành chính công / Phi lợi nhuận',
            'International Trade & Development': 'Thương mại & Phát triển Quốc tế',
            Manufacturing: 'Chế tạo',
            'Media / Entertainment': 'Truyền thông / Giải trí',
            'Petroleum / Energy': 'Dầu mỏ / Năng lượng',
            'Pharma / Healthcare / Biotech': 'Dược phẩm / Chăm sóc sức khỏe / Công nghệ sinh học',
            'Real Estate / Construction / Infrastructure':
                'Bất động sản / Xây dựng / Cơ sở hạ tầng',
            'Technology (IT) / Telecom': 'Công nghệ (Công nghệ thông tin) / Viễn thông',
            'Transportations & Logistics': 'Vận tải & Hậu cần',
            Other: 'Khác',
        },
        countries: {
            'China (Hong Kong SAR)': 'Hồng Kông',
            'Costa Rica': 'Costa Rica',
            'Europe & Sub-Saharan Africa': 'Châu Âu & Châu Phi cận Sahara',
            'Hong Kong': 'Hồng Kông',
            'Korea, South': 'Hàn Quốc',
            'New Zealand': 'New Zealand',
            'Papua-Ny Guinea': 'Papua New Guinea',
            'Puerto Rico': 'Puerto Rico',
            'Saudi Arabia': 'Ả Rập Saudi',
            'South Africa': 'Nam Phi',
            'South Korea': 'Hàn Quốc',
            'Sri Lanka': 'Sri Lanka',
            'Taiwan (Province of China)': 'Đài Loan',
            'The Seychell Islands': 'Seychelles',
            'United Arab Emirates': 'Các Tiểu Vương Quốc Ả Rập Thống Nhất',
            'United Kingdom': 'Vương quốc Anh',
            'Ivory Coast': 'Bờ biển Ngà',
            Afghanistan: 'Afghanistan',
            Algeria: 'Algeria',
            Angola: 'Angola',
            Argentina: 'Argentina',
            Armenia: 'Armenia',
            Australia: 'Úc',
            Austria: 'Áo',
            Azerbaijan: 'Azerbaijan',
            Bahamas: 'Bahamas',
            Bahrain: 'Bahrain',
            Bangladesh: 'Bangladesh',
            Belarus: 'Belarus',
            Belgium: 'Bỉ',
            Botswana: 'Botswana',
            Brazil: 'Brazil',
            Bulgaria: 'Bungari',
            Cambodia: 'Campuchia',
            Canada: 'Canada',
            Chile: 'Chile',
            China: 'Trung Quốc',
            Colombia: 'Colombia',
            Congo: 'Congo',
            Croatia: 'Croatia',
            Cyprus: 'Síp',
            Czechia: 'Czechia',
            Denmark: 'Đan mạch',
            Ecuador: 'Ecuador',
            Egypt: 'Ai Cập',
            Estonia: 'Estonia',
            Ethiopia: 'Ethiopia',
            Fiji: 'Fiji',
            Finland: 'Phần Lan',
            France: 'Nước pháp',
            Germany: 'Đức',
            Ghana: 'Ghana',
            Greece: 'Hy Lạp',
            Guernsey: 'Guernsey',
            Hungary: 'Hungary',
            Iceland: 'Iceland',
            India: 'Ấn Độ',
            Indonesia: 'Indonesia',
            Iraq: 'I-rắc',
            Ireland: 'Ireland',
            Israel: 'Israel',
            Italy: 'Ý',
            Japan: 'Nhật Bản',
            Jersey: 'Jersey',
            Jordan: 'Jordan',
            Kazakhstan: 'Kazakhstan',
            Kenya: 'Kenya',
            Kuwait: 'Kuwait',
            Laos: 'Lào',
            Latvia: 'Latvia',
            Lebanon: 'Lebanon',
            Lithuania: 'Lithuania',
            Luxembourg: 'Luxembourg',
            Malaysia: 'Malaysia',
            Malta: 'Malta',
            Mauritania: 'Mauritania',
            Mauritius: 'Mauritius',
            Mexico: 'Mexico',
            Mongolia: 'Mông Cổ',
            Morocco: 'Maroc',
            Myanmar: 'Myanmar',
            Namibia: 'Namibia',
            Netherlands: 'Hà Lan',
            Nigeria: 'Nigeria',
            Norway: 'Na Uy',
            Oman: 'Oman',
            Pakistan: 'Pakistan',
            Panama: 'Panama',
            Paraguay: 'Paraguay',
            Peru: 'Peru',
            Philippines: 'Phi-líp-pin',
            Poland: 'Ba Lan',
            Portugal: 'Bồ Đào Nha',
            Qatar: 'Qatar',
            Romania: 'Romania',
            Russia: 'Nga',
            Senegal: 'Senegal',
            Serbia: 'Xéc-bi-a',
            Singapore: 'Singapore',
            Slovakia: 'Xlô-va-ki-a',
            Slovenia: 'Slovenia',
            Spain: 'Tây Ban Nha',
            Sudan: 'Sudan',
            Swaziland: 'Swaziland',
            Sweden: 'Thụy Điển',
            Switzerland: 'Thụy sĩ',
            Syria: 'Syria',
            Taiwan: 'Đài loan',
            Tanzania: 'Tanzania',
            Thailand: 'Thái Lan',
            Tonga: 'Tonga',
            Turkey: 'Thổ Nhĩ Kỳ',
            Ukraina: 'Ukraine',
            Ukraine: 'Ukraine',
            USA: 'Hoa Kỳ',
            Uzbekistan: 'U-dơ-bê-ki-xtan',
            Vanuatu: 'Vanuatu',
            Vietnam: 'Việt Nam',
            Zambia: 'Zambia',
        },
        languages: {
            Aceh: 'Tiếng Aceh',
            Afrikaans: 'Tiếng Afrikaans',
            Albanian: 'Tiếng Albanian',
            Amharic: 'Tiếng Amharic',
            Arabic: 'Tiếng Ả Rập',
            Arakanese: 'Tiếng Arakanese',
            Armenian: 'Tiếng Armenia',
            Azeri: 'Tiếng Azeri',
            Badini: 'Tiếng Badini',
            Basque: 'Tiếng Basque',
            Belarusian: 'Tiếng Belarus',
            Bengali: 'Tiếng Bengali',
            Berber: 'Tiếng Berber',
            Bosnian: 'Tiếng Bosnia',
            Bulgarian: 'Tiếng Bungari',
            Burmese: 'Tiếng Miến Điện',
            Cantonese: 'Tiếng Quảng Đông',
            Catalan: 'Tiếng Catalan',
            Cebuano: 'Tiếng Cebuano',
            Chechen: 'Tiếng Chechnya',
            Chin: 'Tiếng Trung Quốc',
            Chinese: 'Tiếng Trung Quốc',
            Croatian: 'Tiếng Croatia',
            Czech: 'Tiếng Séc',
            Danish: 'Tiếng Đan Mạch',
            Dari: 'Tiếng Dari',
            Dutch: 'Tiếng Hà Lan',
            English: 'Tiếng Anh',
            Estonian: 'Tiếng Estonia',
            Faroese: 'Tiếng Faroese',
            Filipino: 'Tiếng Philipin',
            Finnish: 'Tiếng Phần Lan',
            French: 'Tiếng Pháp',
            German: 'Tiếng Đức',
            Greek: 'Tiếng Hy Lạp',
            Greenlandic: 'Tiếng Greenlandic',
            Hausa: 'Tiếng Hausa',
            Hebrew: 'Tiếng Do Thái',
            Hindi: 'Tiếng Hindi',
            Hungarian: 'Tiếng Hungary',
            Icelandic: 'Tiếng Iceland',
            Indonesian: 'Tiếng Indonesia',
            Italian: 'Tiếng Ý',
            Japanese: 'Tiếng Nhật Bản',
            Kazakh: 'Tiếng Kazakh',
            Kinyarwanda: 'Tiếng Kinyarwanda',
            Kirundi: 'Kirundi',
            Korean: 'Tiếng Hàn Quốc',
            Kurdish: 'Tiếng Kurd',
            Kurmanji: 'Tiếng Kurmanji',
            Kven: 'Tiếng Kven',
            Latin: 'Tiếng Latin',
            Latvian: 'Tiếng Latvia',
            Lingala: 'Tiếng Lingala',
            Lithuanian: 'Tiếng Lithuania',
            Macedonian: 'Tiếng Macedonian',
            Malagasy: 'Tiếng Malagasy',
            Malaysian: 'Tiếng Malaysia',
            Mandarin: 'Tiếng Quan Thoại',
            Mongolian: 'Tiếng Mông Cổ',
            Nepali: 'Tiếng Nepal',
            Norwegian: 'Tiếng Nauy',
            Oromo: 'Tiếng Oromo',
            Other: 'Khác',
            Panjabi: 'Tiếng Panjabi',
            Pashto: 'Tiếng Pashto',
            Persian: 'Tiếng Ba Tư',
            Polish: 'Tiếng Ba Lan',
            Portuguese: 'Tiếng Bồ Đào Nha',
            Punjabi: 'Tiếng Punjabi',
            Romanes: 'Tiếng Romanes',
            Romani: 'Tiếng Romani',
            Romanian: 'Tiếng Rumani',
            Russian: 'Tiếng Nga',
            Sami: 'Tiếng ',
            Serbian: 'Tiếng Serbia',
            Sign_language: 'Ngôn ngữ ký hiệu',
            Slovak: 'Tiếng Slovak',
            Slovene: 'Tiếng Slovene',
            Somali: 'Tiếng Somali',
            Sorani: 'Tiếng Sorani',
            Spanish: 'Tiếng Tây Ban Nha',
            Swahili: 'Tiếng Swahili',
            Swedish: 'Tiếng Thụy Điển',
            Tagalog: 'Tiếng Tagalog',
            Tamil: 'Tiếng Tamil',
            Thai: 'Tiếng Thái Lan',
            Tigrinya: 'Tiếng Tigrinya',
            Turkish: 'Tiếng Thổ Nhĩ Kỳ',
            Ukrainian: 'Tiếng Ukraina',
            Urdu: 'Tiếng Urdu',
            Uyghur: 'Tiếng Uyghur',
            Vietnamese: 'Tiếng Việt',
            Wolof: 'Tiếng Wolof',
        },
    },
    emailverification: {
        headerLabel: 'Email xác thực',
        verifyingEmail: 'Xác minh e-mail',
        emailVerifySuccess: 'Email của bạn đã được xác minh!',
        emailVerifyFailure: 'Đã xảy ra lỗi ... hãy thử lại sau hoặc liên hệ với bộ phận hỗ trợ',
        gotoMyPage: 'Quay lại Trang Của Tôi',
    },
    errors: {
        defaultErrorMessage: 'Đã xảy ra lỗi!',
        logInErrorText: {
            invalidCredentials: 'Tên người dùng hoặc mật khẩu sai',
            inactiveUser:
                'Tài khoản với email được cung cấp không hoạt động. Kiểm tra email của bạn để kích hoạt tài khoản hoặc thử đặt lại mật khẩu của bạn.',
            default: 'Không thể xác thực.',
        },
        registerErrorText: {
            passwordTooShort: 'Mật khẩu phải dài ít nhất 8 chữ số.',
            emailAlreadyInUse: 'Email bạn cung cấp đã được sử dụng.',
            emailTaken:
                'Email đã được sử dụng. Nếu bạn đã sử dụng email trường học của mình, điều này có thể xảy ra vì bạn đã có tài khoản trước khi nền tảng được nâng cấp (tại higheringtalent.org).',
            default: 'Không thể tạo tài khoản.',
        },
        invalidTokenText: {
            default: 'Mã thông báo của bạn không hợp lệ hoặc đã hết hạn.',
        },
        passwordErrorText: {
            passwordTooShort: 'Mật khẩu phải dài ít nhất 8 chữ số.',
            requireNonAlphanumeric: 'Mật khẩu phải chứa ít nhất một ký tự đặc biệt.',
            requireLowerCase: 'Mật khẩu phải chứa ít nhất một chữ cái thường.',
            requireUpperCase: 'Mật khẩu phải chứa ít nhất một chữ cái viết hoa.',
            requireUniqueChars: 'Mật khẩu phải chứa ít nhất 6 ký tự khác nhau',
            default: 'Không thể thay đổi mật khẩu',
        },
        recoverErrorText: {
            userNotFound: 'Tài khoản không tồn tại! Vui lòng liên hệ với bộ phận hỗ trợ.',
            userAlreadyActive: 'Người dùng đã được kích hoạt!\nVui lòng thử đăng nhập.',
            emailAlreadyInUse:
                'Email được cung cấp đã được sử dụng.\nNếu bạn muốn tiếp tục kích hoạt tài khoản, hãy thử một email khác hoặc đăng nhập bằng một mạng xã hội khác. Nếu không, hãy chuyển đến trang chủ và đăng nhập vào tài khoản của bạn.',
            default: 'Không thể kích hoạt tài khoản.\nVui lòng thử lại sau.',
        },
        socialAuthErrorText: {
            errorTitle: 'Không thể đăng nhập bằng {nhà cung cấp}',
            invalidProviderGoogle:
                'Tài khoản với email được cung cấp không được kết nối với Google. Hãy thử đăng nhập bằng LinkedIn, Facebook hoặc email.',
            invalidProviderFacebook:
                'Tài khoản có email được cung cấp không được kết nối với Facebook. Hãy thử đăng nhập bằng Google, LinkedIn hoặc email.',
            invalidProviderLinkedIn:
                'Tài khoản có email được cung cấp không được kết nối với LinkedIn. Hãy thử đăng nhập bằng Google, Facebook hoặc email chẳng hạn.',
            invalidProviderWeChat:
                'Tài khoản có email được cung cấp không được kết nối với WeChat. Hãy thử đăng nhập bằng Google, Facebook hoặc email.',
        },
        uniConnErrorText: {
            emailNotAvailable:
                'Email bạn cung cấp đã được sử dụng. Điều này có thể do bạn đã có một tài khoản trước khi nền tảng được nâng cấp (tại higheringtalent.org). Vui lòng liên hệ với bộ phận hỗ trợ.',
            invalidEmailDomain:
                'Miền email sử dụng không khớp với trường đại học được cung cấp. Vui lòng chọn trường đại học một cách chính xác.',
            existingConnection: 'Tài khoản này đã được kết nối với trường đại học được cung cấp',
            default: 'Không thể bắt đầu xác minh.',
        },
        spotlightErrors: {
            userUpdate: {
                emailAlreadyInUse: 'Email đã được sử dụng',
                default: 'Không thể cập nhật',
            },
        },
    },
    favorites: {
        header: 'Mục yêu thích của tôi',
        active: 'Hoạt động',
        expired: 'Hết hạn',
        expiresThisMonth: 'Hạn nộp hồ sơ trong tháng này',
        expiresThisWeek: 'Hạn nộp hồ sơ trong tuần này',
        expiresLater: 'Hạn nộp hồ sơ muộn hơn',
        noActiveFavorites: 'Bạn không có vị trí yêu thích đang hoạt động',
        noExpired: 'Bạn không có vị trí yêu thích đã hết hạn',
    },
    findcompanies: {
        headerLabel: 'Tìm công ty',
        companyListLabel: 'Các công ty',
    },
    findjobs: {
        header: 'Tìm việc',
        changeFilters: 'Thay đổi bộ lọc',
        recruitmentModule: {
            body: 'Bạn là nhân viên tuyển dụng, chuyên gia nghề nghiệp hay đơn giản là\n        quan tâm đến việc tuyển dụng sinh viên tài năng?',
            createJob: 'Bấm vào đây để tạo bài đăng tuyển dụng',
        },
    },
    general: {
        documentTitle: 'Nền tảng cơ hội toàn cầu',
        email: 'E-mail',
        password: 'Mật khẩu',
        confirmPassword: 'Xác nhận mật khẩu',
        loading: 'Đang tải',
        ok: 'VÂNG',
        save: 'Lưu',
        add: 'Thêm vào',
        close: 'Đóng',
        delete: 'Xóa bỏ',
        cancel: 'Hủy bỏ',
        done: 'Làm xong',
        continue: 'Tiếp tục',
        back: 'Quay lại',
        next: 'Kế tiếp',
        finish: 'Hoàn thành',
        success: 'Thành công',
        error: 'Lỗi',
        description: 'Mô tả',
        months: {
            0: 'Tháng một',
            1: 'Tháng hai',
            2: 'Tháng ba',
            3: 'Tháng tư',
            4: 'Tháng năm',
            5: 'Tháng sáu',
            6: 'Tháng bảy',
            7: 'Tháng tám',
            8: 'Tháng chín',
            9: 'Tháng mười',
            10: 'Tháng mười một',
            11: 'Tháng mười hai',
        },
        days: {
            0: 'Chủ nhật',
            1: 'Thứ hai',
            2: 'Thứ ba',
            3: 'Thứ tư',
            4: 'Thứ năm',
            5: 'Thứ sáu',
            6: 'Thứ bảy',
        },
        dialogs: {
            helperTexts: {
                checkHasPendingAction: 'Kiểm tra xác minh đang chờ xử lý của bạn',
                verifySchoolConnection:
                    'Xác minh kết nối trường học của bạn để truy cập các tài nguyên này',
                logInToAccessMoreFeatures: 'Hàng ngàn cơ hội nghề nghiệp quốc tế',
            },
        },
        minutesShort: 'min',
        poweredBy: 'Được cung cấp bởi',
    },
    gptw: {
        company: {
            alt: 'GPTW',
            tooltip: 'Công ty này là một công ty được chứng nhận bởi "Great Place To Work"',
        },
        posting: {
            label: {
                alt: 'GPTW',
                tooltip: 'Bài đăng này thuộc về tổ chức "Great Place To Work"',
            },
            detail: {
                alt: 'GPTW',
                tooltip: {
                    isCertified: '{companyName}được chứng nhận bởi Great Place To Work',
                    readMore: 'Bấm để đọc thêm',
                },
            },
        },
    },
    jobdetail: {
        detailModule: {
            deadline: 'Hạn nộp hồ sơ',
            location: 'Địa điểm',
            employmentType: 'Loại việc làm',
            languageRequirements: 'Yêu cầu ngôn ngữ',
            workPermitRequirements: 'Yêu cầu giấy phép lao động',
            preferredEducationField: 'Lĩnh vực giáo dục ưu tiên',
            preferredEducationLevel: 'Trình độ học vấn ưu tiên',
            jobTags: 'Thẻ',
            apply: 'Ứng tuyển ngay',
            verificationRequired: 'Bạn cần xác minh e-mail của trường để đăng ký.',
            verificationRequiredHint: 'Bạn cần xác minh e-mail của trường để đăng ký',
            verificationPending: 'Bạn có một xác minh đang chờ xử lý tại trường này',
            verificationPendingHint: 'Bạn có một xác minh đang chờ xử lý tại trường này',
        },
        invalidJobAd: {
            caption:
                'Xin lỗi, nhưng chúng tôi không thể tìm thấy vị trí này. Nếu bạn cho rằng đây là lỗi, vui lòng liên hệ với bộ phận hỗ trợ bằng cách sử dụng hộp thoại bên dưới.',
            btn: 'Tìm việc làm khác',
        },
    },
    mypage: {
        header: 'Trang của tôi',
        suggestedPositions: 'Các vị trí được đề xuất',
        favoriteModule: {
            header: 'Vị trí yêu thích của tôi',
            seeAll: 'Xem toàn bộ',
            noFavorites: 'Bạn không có vị trí yêu thích đang hoạt động',
        },
    },
    recoverpassword: {
        createPassword: 'Tạo một mật khẩu mới',
        newPasswordLabel: 'Mật khẩu mới',
        newPasswordPlaceholder: 'Mật khẩu',
        confirmPasswordLabel: 'Xác nhận mật khẩu',
        confirmPasswordPlaceholder: 'Xác nhận mật khẩu',
        resetPasswordButton: 'Đặt lại mật khẩu',
        resettingPassword: 'Đặt lại mật khẩu',
        passwordsNotMatching: 'Mất khẩu không hợp lệ.',
    },
    recoveruser: {
        headerLabel: 'Khôi phục tài khoản Highered',
        accountActivation: 'Kích hoạt tài khoản',
        step1: {
            header: 'Chào mừng đến với nền tảng mới của chúng tôi!',
            subHeader: 'Chọn cách bạn muốn kết nối với tài khoản của mình',
            description:
                'Để quá trình đăng nhập đơn giản hơn, chúng tôi khuyên bạn nên kết nối tài khoản của mình với ít nhất một trong các dịch vụ sau.',
            OR: 'hoặc',
            emailAndPassword: 'Sử dụng email của riêng bạn',
        },
        step2: {
            header: 'Sử dụng email và mật khẩu',
            description:
                'Đây là email chính sẽ được liên kết với tài khoản của bạn. Chúng tôi khuyên bạn nên sử dụng một email khác với email của trường đại học để bạn có thể giữ quyền truy cập vào dữ liệu kể cả sau khi bạn tốt nghiệp. Bạn có thể dễ dàng kiểm soát những email bạn nhận được từ chúng tôi trong cài đặt tài khoản của bạn.',
            invalidEmail: 'Email được cung cấp không phải là một email hợp lệ.',
            passwordsNotMatch: 'Mật khẩu phải khớp',
            passwordDescription01:
                'Để đảm bảo an toàn cho tài khoản của bạn, bạn cần đặt một mật khẩu mới. Vui lòng tạo mật khẩu như sau:',
            passwordDescription02: 'Tối thiểu 8 ký tự',
            passwordDescription03: 'Ít nhất một ký tự viết thường (a-z)',
            passwordDescription04: 'Ít nhất một ký tự viết hoa (A-Z)',
            passwordDescription05: 'Ít nhất một số hoặc ký hiệu đặc biệt (0-9,! # $, v.v.)',
            passwordDescription06: 'Ít nhất 6 ký tự duy nhất',
            repeatPassword: 'Lặp lại mật khẩu',
        },
        step3: {
            header: 'Đang kích hoạt người dùng',
            loadingHints: {
                0: 'Đang tải dữ liệu người dùng',
                1: 'Chuẩn bị sẵn sàng mọi thứ',
                2: 'Tính năng mới sắp được ra mắt',
                3: 'Sắp xong!',
            },
            successHeader: 'Tài khoản của bạn hiện đã sẵn sàng hoạt động!',
            successSubheader: 'Bây giờ bạn có thể truy cập các tính năng độc quyền mới!',
            errorHeader: 'Không thể kích hoạt tài khoản',
            ifWrongContact: 'Nếu bạn cho rằng điều này là sai, vui lòng liên hệ với bộ phận hỗ trợ',
            contactForHelp: 'Liên hệ để được giúp đỡ',
            goBack: 'Quay lại',
        },
    },
    resourcesInternal: {
        header: 'Tài nguyên',
        resourceTypeHeader: 'Thể loại',
        resourceNoContent: 'Trường của bạn chưa kích hoạt chức năng tài nguyên.',
        resourceFolderNoContent: 'Không có tài nguyên nào trong thư mục này',
        resourceTitleHeader: 'Chức vụ',
        resourcePublishDateHeader: 'Được phát hành',
        searchPlaceholder: 'Tìm kiếm tên hoặc từ khóa ...',
        cvTemplateHeader:
            'MẪU SƠ YẾU LÝ LỊCH CỦA HIGHERED (PHÙ HỢP VỚI PHẦN MỀM QUẢN TRỊ TUYỂN DỤNG)',
        cvTemplateSubtitle: 'Tải xuống ở đây!',
    },
    shared: {
        userNavSection: {
            myPage: 'Trang của tôi',
            myProfile: 'Thông tin của tôi',
            myTests: 'Đánh giá',
            myApplications: 'Các ứng dụng',
            myFavorites: 'Yêu thích',
            resources: 'Tài nguyên',
            calendar: 'Lịch',
            documents: 'Tải lên CV',
        },
        searchModule: {
            searchBar: { label: 'Tìm kiếm theo tiêu đề hoặc từ khóa' },
            filters: { clearFilters: 'Xóa bộ lọc' },
            filterLimit: {
                title: 'Đã đạt đến giới hạn bộ lọc',
                message: 'Không thể chọn thêm bộ lọc nào thuộc loại này',
            },
        },
        postingModule: {
            postingModule: {
                positions: 'Vị trí',
                estimatedCount: 'ca {đếm} trong tổng số {Tổng số Đếm}',
                knownCount: '{đếm} trong tổng số {tổng số Đếm}',
                noMatchFound: 'Không thể tìm thấy bất kỳ điều gì phù hợp với tiêu chí của bạn',
            },
            postItem: { applyBefore: 'Hạn nộp hồ sơ' },
            postCard: { deadline: 'Thời hạn' },
        },
        loginModule: {
            emailVerificationTip: 'Có thể mất vài phút để nó đến hộp thư đến của bạn.',
            noEmail: 'Không có email? Vui lòng kiểm tra bộ lọc thư rác của bạn hoặc:',
            logIn: 'Đăng nhập',
            socialAuthBtns: {
                continueWithFacebook: 'Tiếp tục với Facebook',
                continueWithGoogle: 'Tiếp tục với Google',
                continueWithLinkedIn: 'Tiếp tục với LinkedIn',
                continueWithWeChat: 'Tiếp tục với WeChat',
            },
            verifyEmail: {
                verifyYourEmail: 'Vui lòng xác minh email của bạn',
                weSentAnEmailTo: 'Chúng tôi đã gửi xác minh tới',
                continueToSignIn: 'Tiếp tục đăng nhập',
                resendEmail: 'Gửi lại liên kết xác minh',
                newEmailSent: 'Email mới được gửi',
            },
            registerForm: {
                recommendation:
                    'Chúng tôi khuyên bạn nên sử dụng email cá nhân của mình thay vì email của trường học\n            để đảm bảo bạn có quyền truy cập vào dữ liệu của mình sau khi\n            tốt nghiệp.',
                register: 'Đăng ký',
                passwordsNotMatch: 'Mật khẩu không trùng khớp',
            },
            logInPaper: {
                useEmail: 'hoặc sử dụng email của bạn',
                noAccount: 'Không có tài khoản?',
                signUp: 'Đăng ký',
                logInToAccess: 'Đăng nhập để truy cập tính năng này',
                showAllOptions: 'Hiển thị tất cả các tùy chọn đăng nhập',
                hideAllOptions: 'Hiện ít hơn',
            },
            logInForm: { logIn: 'Đăng nhập', forgotPassword: 'Quên mật khẩu?' },
            forgotPassword: {
                title: 'Yêu cầu đặt lại mật khẩu',
                description:
                    'Đừng lo lắng - mọi người đều quên mật khẩu của họ một lúc nào đó.\n                Nhập email của bạn vào bên dưới để đặt lại mật khẩu của bạn',
                resetPassword: 'Đặt lại mật khẩu',
                emailSentTitle: 'Sự giúp đỡ của bạn đang được tiến hành!',
                emailHasBeenSent:
                    'Một email đã được gửi tới\n                            <br>\n                            <strong>{email}</strong>\n                            <br>\n                            kèm theo hướng dẫn về cách đặt lại mật khẩu của bạn. Vui lòng kiểm tra\n                            hộp thư đến của bạn.',
                noEmail: 'Không có email?',
                sendEmailOneMoreTime: 'Gửi email một lần nữa',
                resendErrorTitle: 'Lỗi khi khôi phục mật khẩu',
                resendErrorMessage: 'Không thể gửi email khôi phục mật khẩu. Có thể sai email?',
            },
        },
        termsAndConds: {
            termsAndConditions: 'Điều khoản và điều kiện',
            privacyPolicy: 'Chính sách bảo mật',
            talentPanel: 'Trường học/Nhà tuyển dụng?',
        },
        favoriteModule: {
            favoriteCard: {
                deleted: 'Đã xóa',
                deletedTitle: 'Vị trí này không còn khả dụng',
            },
        },
        pageNotFound: {
            header: '404',
            description: 'Có vẻ như trang bạn đang tìm kiếm không còn ở đây nữa.',
            goToHome: 'Đi đến trang chủ',
            contactus: 'Liên hệ chúng tôi',
        },
        chat: {
            liveNow: 'Trò chuyện trực tuyến ngay bây giờ!',
            seeAll: 'Tất cả',
            schoolSpecificChats: 'Truy cập nhanh',
            help: 'Cần giúp đỡ?',
            chatExistsLabel: 'Trò chuyện tồn tại',
        },
        countdown: {
            day: 'ngày',
            days: 'ngày',
            hour: 'giờ',
            hours: 'giờ',
            minute: 'phút',
            minutes: 'phút',
            second: 'giây',
            seconds: 'giây',
        },
    },
    spotlight: {
        header: 'Hồ sơ của tôi',
        saveChangesToSubmit: 'Lưu hồ sơ của bạn để các thay đổi có hiệu lực',
        saveChanges: 'Lưu thay đổi',
        saveSuccessful: 'Các thay đổi của bạn đã được lưu thành công',
        personalDetails: {
            header: 'Thông tin cá nhân',
            firstName: 'Tên',
            lastName: 'Họ',
            nationality: 'Quốc tịch',
            gender: 'Giới tính',
            uploadProfileImage: 'Tải ảnh lên',
            genderOptions: {
                male: 'Nam giới',
                female: 'Nữ giới',
                other: 'Khác',
                none: 'Không muốn tiết lộ',
                unknown: 'Không xác định',
            },
            wrongFileTypeErrorHeader: 'Loại tệp không hợp lệ',
            wrongFileTypeErrorDescription: 'Bạn chỉ có thể tải lên hình ảnh',
        },
        summary: { header: 'Tóm tắt chung' },
        contactDetails: {
            header: 'Chi tiết liên hệ',
            contactEmail: 'Địa chỉ email liên lạc',
            phoneNumberHeader: 'số điện thoại',
            countryCode: 'Mã quốc gia',
            phoneNumber: 'Số điện thoại',
            invalidEmail: 'Email đã nhập không phải là một email hợp lệ.',
            permanentEmail:
                'LƯU Ý: Đây là thay đổi vĩnh viễn. Bạn chỉ có thể đặt email của mình một lần.',
        },
        languages: {
            header: 'Ngôn ngữ',
            languageLabel: 'Ngôn ngữ',
            levelLabel: 'Mức độ',
            addLanguage: 'Thêm ngôn ngữ mới',
            proficiencies: {
                '22f882cc-3cb0-4cfd-a590-ef010f4d798b': 'Trình độ tiểu học',
                '82edcac6-693b-42ea-bf24-0a52774f395c': 'Năng lực làm việc hạn chế',
                'a97f6798-7280-4ce7-8896-6d4a8fb58c63': 'Trình độ làm việc chuyên nghiệp',
                '93b37709-3f2d-4853-ac77-b8c0dd07243e': 'Trình độ chuyên môn đầy đủ',
                '250d296e-d6db-46fb-8c44-07950db80ec4': 'Sự thành thạo tiếng bản xứ hoặc song ngữ',
            },
        },
        education: {
            header: 'Trình độ học vấn',
            addEducation: 'Thêm trình độ học vấn',
            notGraduated: 'Chưa tốt nghiệp',
            graduatedIn: 'Tốt nghiệp năm {năm}',
            dialog: {
                addNewEducation: 'Thêm trình độ học vấn mới',
                degreeTitle: 'Chương trình',
                institution: 'Tổ chức',
                degreeType: 'Bằng',
                fieldOfStudy: 'Chuyên ngành',
                cannotFindField: 'Tôi không thể tìm thấy lĩnh vực của mình',
                studyStart: 'Tháng bắt đầu',
                studyEnd: 'Tháng tốt nghiệp',
                invalidDegreeTitle: 'Bạn cần điền vào một tiêu đề của chương trình của bạn.',
                invalidSchool: 'Bạn cần phải chọn một trường học.',
                invalidStartDate: 'Vui lòng chọn ngày bắt đầu.',
                invalidEndDate: 'Vui lòng chọn ngày tốt nghiệp.',
                invalidStudyPeriod: 'Bạn không thể tốt nghiệp trước ngày bắt đầu.',
                invalidDegreeField: 'Vui lòng nhập một lĩnh vực nghiên cứu hợp lệ.',
                invalidDegreeLevel: 'Vui lòng chọn một cấp độ hợp lệ của bằng cấp của bạn.',
                selectStartDate: 'Ngày bắt đầu',
                selectEndDate: 'Ngày tốt nghiệp',
                degrees: {
                    '5b468395-7bf7-4f14-88d9-32096884d4ef': 'Cử nhân',
                    '09f419fa-1517-41ce-970c-df0d073fc440': 'Thạc sĩ',
                    '2c917ed6-5bb7-4e23-95ab-60c55d8df135': 'Thạc sĩ quản trị kinh doanh',
                    '1fff1451-f07c-415c-954a-63b1e5f44fc8': 'Chuyên gia quản trị cơ sở dữ liệu',
                    '2fbd6155-d939-40cc-970d-283be0aef433': 'Tiến sĩ',
                },
                diciplins: {
                    '383c2086-24da-4fe2-977b-7e3d4da85f8e': 'Nông nghiệp & Lâm nghiệp',
                    'c8fb1348-bdac-4ed3-af7a-a831376d04b7': 'Khoa học Ứng dụng & Chuyên môn',
                    '5c665d94-5124-4226-a4f6-da8cca47e3f6': 'Nghệ thuật, Thiết kế & Kiến trúc',
                    '06b028e2-d7ed-4281-8668-1009d6da1c35': 'Quản lý kinh doanh',
                    '747624bb-0174-4961-a3c0-dbe4f1cb750d':
                        'Khoa học máy tính & Công nghệ thông tin',
                    'ede2bbdb-7a1d-466c-99e5-bcab52e07d69': 'Kinh tế học',
                    '5c0432d4-9297-429a-85c4-3305d207764e': 'Giáo dục & Đào tạo',
                    '8198b6ea-5b28-4be2-afbc-45df759c65cb': 'Công nghệ kỹ thuật',
                    '7e5c0527-d1ec-4125-945e-138ec473e8dd':
                        'Nghiên cứu Môi trường & Khoa học Trái đất',
                    '3babe28b-6285-4a03-b0b8-43f55be393cd': 'Khách sạn, Giải trí & Thể thao',
                    '9eebcc51-385e-4122-88a1-6dd3efbaf896': 'Nhân văn',
                    '390cf111-b55a-4bb7-a6b6-1cc2b21a248f': 'Báo chí & Truyền thông',
                    'a2744908-9521-4330-a07d-3680b058d0a6': 'Luật',
                    '947993e1-b723-4d85-8cd9-a4ae46cd623e': 'Tiếp thị',
                    'c98802c8-74a5-4a98-99ba-84eb76fd1a60':
                        'Thạc sĩ Khoa học về Đổi mới và Kinh doanh',
                    'bca263cc-3d17-4ad8-b70e-e2bfe04421fa': 'Thạc sĩ quản lý phát triển',
                    'a37667e2-5713-4157-82e9-78c10760d2de': 'Thạc sĩ Khoa học về Khoa học Dữ liệu',
                    '72277bb7-9d5e-422a-a2b4-8a8fb8be7143': 'Y học & Sức khỏe',
                    'bd84a8cd-ce66-4c61-86a8-7fcb6644cc5d': 'Thạc sĩ tài chính',
                    '9e665ac9-9611-4508-af4b-22e91f167ea4': 'Thạc sĩ Nghiên cứu Kinh doanh Quốc tế',
                    'baf5bb0a-d0ab-4c13-aacc-c6a8a90e2fcf': 'Thạc sĩ Phân tích Kinh doanh',
                    '7d832109-642a-4730-aada-26927eb683ee': 'Thạc sĩ quản lý',
                    'baf05a5a-faba-4f30-9254-9cd73bb63bbf': 'Khoa học tự nhiên & Toán học',
                    '828cc4ac-1f2b-4133-8e29-ba1347585ae6': 'Khoa học Xã hội',
                    '44c1f8cf-8696-4638-bc03-9763c2de32af': 'Khác',
                },
            },
        },
        workAuthorization: {
            header: 'Ủy quyền công việc',
            addWorkAuthorization: 'Thêm ủy quyền công việc',
            implicitValue: 'Dựa trên quốc tịch của bạn',
            dialog: {
                selectCountry: 'Chọn quốc gia',
                addEuWorkAuthorization: 'Thêm ủy quyền công việc của Liên minh Châu Âu',
            },
        },
        communication: {
            header: 'Liên lạc',
            sendMeUpdatesDescription:
                'Vui lòng gửi cho tôi tin tức nghề nghiệp, vị trí và thông tin cập nhật về công ty qua email',
        },
        errors: {
            imageUpload: {
                title: 'Không thể tải lên hình ảnh.',
                message: 'Hình ảnh quá lớn!',
            },
        },
        exitDialog: {
            title: 'Các thay đổi chưa được lưu sẽ bị mất',
            message:
                'Bạn đang cố thoát khỏi trang mà không lưu các thay đổi của mình. Bạn có muốn lưu hồ sơ của mình trước khi tiếp tục không?',
            stayAction: 'Ở lại trang này',
            saveAction: 'Lưu hồ sơ',
            continueAction: 'Tiếp tục mà không lưu',
        },
    },
    tests: {
        header: 'Kiểm tra',
        unauthorized:
            'Các bài kiểm tra đang trong giai đoạn thử nghiệm. Bạn chưa có quyền truy cập vào các tính năng này. Nó sẽ sớm được ra mắt!',
        error: 'Đã xảy ra lỗi khi cố gắng tải các bài kiểm tra. Vui lòng thử lại sau.',
        assessmentModule: { header: 'Đánh giá của bạn' },
        completedYourProfile:
            'Bạn cần hoàn thành hồ sơ của mình để có quyền truy cập vào bài đánh giá này',
        toMyProfile: 'Chỉnh sửa hồ sơ của tôi',
    },
    vfair: {
        header: 'Sự kiện ảo EFMD',
        activeNow: 'Đang diễn ra',
        visibilityPrivate: 'Riêng tư',
        visibilityNetwork: 'Mạng',
        visibilityOpen: 'Mở',
        interested: 'Đăng ký',
        attend: 'Tham dự sự kiện',
        enterEvent: 'Nhập sự kiện ảo',
        notinterested: 'Tôi không còn hứng thú nữa',
        shownInterest: 'Đã đăng ký',
        signUpToday: 'Hãy đăng ký ngay hôm nay!',
        vfairsInfo:
            'Kết nối với các công ty và tổ chức từ khắp nơi trên thế giới, trong một môi trường mô phỏng hội chợ việc làm tinh vi cho phép tương tác trong thời gian thực giữa nhà tuyển dụng và ứng viên. Bấm vào sự kiện ảo mà bạn quan tâm và đăng ký để nhận thông báo.',
        recruitingOrgs: 'Các công ty & tổ chức tuyển dụng',
        preRegistered: 'Đã đăng ký trước',
        prepareForTheFair: 'Chuẩn bị cho sự kiện ảo',
        privateVFairHeader: 'Sự kiện ảo trong khuôn viên trường',
        privateVFairMessage:
            'Sự kiện ảo này được tổ chức trên nền tảng trường học EFMD và do đó không thể truy cập được từ đây.',
        schoolNotJoinedNetworkEventMessage:
            'Trường học của bạn chưa đăng ký sự kiện ảo này, hãy liên hệ với giám đốc chương trình hoặc bộ phận nghề nghiệp của bạn để yêu cầu tham gia.',
        companyNotJoinedNetworkEventMessage:
            'Tổ chức của bạn không có Gian hàng ảo đang hoạt động tại sự kiện này. Liên hệ với Highered để yêu cầu tham gia.',
        pavilions: 'Gian hàng',
        general: 'Chung',
        allCompanies: 'Tất cả các công ty',
        lobby: 'Sảnh',
        inviteCode: 'Mã mời',
        eventRequiresInvitation: 'Sự kiện này yêu cầu một lời mời',
        haveCode: 'Tôi có mã',
        checkCode: 'Kiểm tra mã',
        invalidCode: 'Mã không hợp lệ',
        registeredSuccessfully: 'Đã đăng ký thành công',
        pavilionTabs: {
            home: 'trang chủ',
            companies: 'các công ty',
            articles: 'bài viết',
            jobs: 'việc làm',
            events: 'sự kiện',
        },
        events: {
            noEventsAvailable: 'Không có sự kiện nào',
            showCompleted: 'Hiển thị những sự kiện đã kết thúc',
            hideCompleted: 'Ẩn những sự kiện đã kết thúc',
            liveNow: 'Đang diễn ra',
            joinTheEvent: 'Tham gia sự kiện',
            addToCalendar: 'Thêm vào lịch',
        },
        links: {
            masterclasses: {
                header: 'Masterclasses',
                buttonCaption: 'Xem các Masterclasses',
                description:
                    'Xem một loạt các lớp học chất lượng hàng đầu bao gồm “Tối ưu hóa CV để được tuyển dụng”, “Khai thác hồ sơ Linkedin của bạn” và “Đàm phán lương”, trong số nhiều lớp học khác, cho tất cả các giai đoạn trong lộ trình sự nghiệp của bạn!',
            },
            detailsmasterclass: { header: 'Tham dự lớp học chính' },
            cv: {
                header: 'Mẫu cv',
                buttonCaption: 'Tải xuống mẫu CV',
                description:
                    'Sử dụng mẫu CV thân thiện với ATS tại Highered để tạo ấn tượng chuyên nghiệp với nhà tuyển dụng.',
            },
            elevatorPitch: {
                header: 'Thử thách Bán hàng Nhanh',
                buttonCaption: 'Gửi lời chào hàng của bạn',
                description:
                    'Tham gia "Thử thách hoàn hảo trên sân cỏ"! Đây là cơ hội để bạn quảng cáo giá trị của mình cho hàng trăm nhà tuyển dụng từ các công ty và tổ chức hàng đầu thế giới',
            },
        },
        footerHeaders: {
            social: 'Theo dõi chúng tôi để cập nhật thêm thông tin',
            sponsored: 'Được tài trợ bởi',
            organized: 'Được tổ chức bởi',
        },
        educationPopup: {
            step00: {
                header: 'Chia sẻ giáo dục của bạn',
                subtitle: 'Để tiếp tục, hãy cho nhà tuyển dụng biết thêm về bạn',
                continueLabel: 'Thêm trình độ học vấn của tôi',
                leaveLabel: 'Miễn nhiệm',
            },
            step01: { header: 'Hãy cho chúng tôi biết trình độ học vấn của bạn' },
            step02: { loadingLabel: 'Chờ một chút ...' },
            step03: {
                header: 'Giáo dục đã hoàn thành',
                subtitle:
                    'Giờ đây, bạn có thể chia sẻ hồ sơ của mình và trở nên thú vị hơn giữa các nhà tuyển dụng',
                continueLabel: 'Tiếp tục khám phá sự kiện ảo',
            },
            error: {
                header: 'Rất tiếc! Đã xảy ra lỗi!',
                subtitle:
                    'Chúng tôi không thể lưu trữ thông tin trình độ học vấn của bạn. Vui lòng thử lại sau.',
            },
        },
    },
};
